import { Divider, Stack, Typography } from '@mui/material'
import { Fragment } from 'react'

import {
  PreSale,
  PreSaleLotteryConfirmationFragment,
} from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type LotterySubTitleCellProps = {
  preSale: PreSaleLotteryConfirmationFragment &
    Pick<PreSale, 'firstComeFirstServed'>
}
export const LotterySubTitleCell: Cell<LotterySubTitleCellProps> = ({
  preSale,
}) => {
  const { t } = useTranslation('lotteryConfirmation')
  const contents = [
    {
      title: t('preSale', '先行販売'),
      content: preSale.title,
    },
    {
      title: t('applicationDate', '先行抽選受付期間'),
      content: `${preSale?.lottery?.formattedApplicationStartedAt} 〜${preSale?.lottery?.formattedApplicationEndedAt}`,
    },
    ...(preSale?.lottery?.formattedResultNoticedAt
      ? [
          {
            title: t('resultNoticeDate', '当落発表予定日'),
            content: preSale?.lottery?.formattedResultNoticedAt,
          },
        ]
      : []),
    {
      title: t('purchasableDate', '決済期間'),
      content: `${preSale?.lottery?.formattedPurchasableStartedAt} 〜 ${preSale?.lottery?.formattedPurchasableEndedAt}`,
    },
  ]
  return (
    <CellFrame sx={{ pb: 5 }}>
      <Stack sx={{ px: 2, py: 1, bgcolor: 'grey.50' }}>
        <Typography variant="h5" color="text.secondary">
          {t('information', '公演情報')}
        </Typography>
      </Stack>
      <Stack sx={{ pt: 3 }}>
        {contents.map((content, index) => (
          <Fragment key={index}>
            <Stack spacing={1} sx={{ py: 2 }}>
              <Typography variant="subtitle1" color="text.secondary">
                {content.title}
              </Typography>
              <Typography variant="body2">{content.content}</Typography>
            </Stack>
            {index < contents.length - 1 && <Divider />}
          </Fragment>
        ))}
      </Stack>
    </CellFrame>
  )
}
